import { createContext } from "react";

import { ProviderAccContractHelper } from "./ProviderAccContractHelper.tsx";

export const ProviderAccContractContext =
  createContext<ProviderAccContractHelper>({} as ProviderAccContractHelper);
